import React, { ReactElement, useEffect, useState } from 'react';
import { Label, Loader, Select } from 'idsk-react-components';
import { TypCiselnikaEnum } from 'ciselniky-frontend-ts-axios';
import usePolozkyCiselnik from '../../../../hooks/usePolozkyCiselnik';
import PolozkaCiselnik from '../../../../model/ciselniky/PolozkaCiselnik';
import { PREDBEZNA_INFORMACIA } from '../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';

interface Props {
  typCiselnikaEnum: TypCiselnikaEnum;
  fieldName: string;
  label?: string;
  setTyp?: (polozka: PolozkaCiselnik) => void;
  selectedTypKod?: string;
  predbeznaInformacia?: boolean;
  execute?: boolean;
}

const CiselnikPolozkaSelect = ({
  typCiselnikaEnum,
  fieldName,
  label,
  setTyp,
  selectedTypKod,
  predbeznaInformacia = false,
  execute = true,
}: Props): ReactElement => {
  const {
    polozkyCiselnik,
    polozkyCiselnikStatus,
  } = usePolozkyCiselnik(null, [typCiselnikaEnum], null, null, execute);

  const [selectedPolozka, setSelectedPolozka] = useState<string>('');

  useEffect(() => {
    if (polozkyCiselnik && polozkyCiselnik?.length !== 0) {
      setSelectedPolozka(polozkyCiselnik.find(polozka => polozka?.kod === selectedTypKod)?.uuid);
    }
  }, [polozkyCiselnik, selectedTypKod]);

  return (
    <Loader loading={polozkyCiselnikStatus.loading}>
      <>
        {label && (
          <Label className="blue-label" htmlFor="typMaterialu">Typ materiálu</Label>
        )}
        {polozkyCiselnik && (
          <Select
            id={fieldName}
            name={fieldName}
            width="full"
            onChange={({ target }) => {
              setTyp(polozkyCiselnik.find(polozka => polozka.uuid === target.value));
              setSelectedPolozka(target.value);
            }}
            value={selectedPolozka || ''}
          >
            <option>Vyberte</option>
            {(polozkyCiselnik && polozkyCiselnik?.length > 0) ? (
              <>
                {!predbeznaInformacia ? polozkyCiselnik.filter(polozka => polozka.uuid !== PREDBEZNA_INFORMACIA)
                  .map(polozka => <option key={polozka.uuid} value={polozka.uuid}>{polozka.nazov}</option>)
                  : polozkyCiselnik.map(polozka => (
                    <option
                      key={polozka.uuid}
                      value={polozka.uuid}
                    >{polozka.nazov}
                    </option>
                  ))}
              </>
            ) : (
              <option key="emptyOption" value="emptyOption" disabled>
                Nenašiel sa žiadny záznam.
              </option>
            )}
          </Select>
        )}
      </>
    </Loader>
  );
};

export default CiselnikPolozkaSelect;
